export const EventList = [
  "ev_action_board_cell_pointerdown",
  "ev_action_stand_cell_pointerdown",
  "ev_action_piece_cancel",
  "ev_action_piece_lift",
  "ev_action_player_info_click",
  "ev_action_turn_change",
  "ev_action_viewpoint_flip",
  "ev_action_click_for_think_mark",
  "ev_action_promote_select_open",
  "ev_action_promote_select_close",
  "ev_comment_change",
  "ev_edit_mode_short_sfen2_change",
  "ev_edit_mode_short_sfen_change",
  "ev_illegal_click_but_self_is_not_turn",
  "ev_illegal_illegal_accident",
  "ev_illegal_my_turn_but_oside_click",
  "ev_play_mode_move",
  "ev_play_mode_moves_change",
  "ev_play_mode_next_moves",
  "ev_short_sfen_change",
  "ev_turn_offset_change",
  "ev_turn_offset_max_change",
  "update:sp_debug",
  "update:sp_event_log",
  "update:sp_mode",
  "update:sp_turn",
  "update:sp_viewpoint",
]
